import { useQuery } from 'react-query';
import { getProcedureList } from '../api/getProcedureList';
import { masterDataKeys, masterDataStaleTime } from '../api/queryKeys';

/**
 * Fetch procedure master-data list.
 *
 * @param {Object} params - { search, page, limit, sort, isSearch }
 * @param {Object} [options]
 * @param {boolean} [options.enabled=true]
 */
export const useProcedureList = (params, { enabled = true } = {}) => {
  const { data, isLoading, isError, refetch } = useQuery(
    masterDataKeys.procedures(params),
    ({ signal }) => getProcedureList(params, signal),
    {
      enabled,
      staleTime: masterDataStaleTime.BATCH,
      keepPreviousData: true,
    }
  );

  return { data, isLoading, isError, refetch };
};

export default useProcedureList;
